import {
    ForecastCreatePreparedData,
} from '../ShortTermForecastCsvUpload.types'

const keysToDelete: (keyof ForecastCreatePreparedData)[] = [
    'accountNameLabel',
    'originAirportLabel',
    'destinationAirportLabel',
    'tempId',
]
const mapUploadParams = (data: ForecastCreatePreparedData) => {
    const cleanedData = {
        ...data,
    }

    keysToDelete.forEach((key) => {
        delete cleanedData[key]
    })
    return cleanedData
}

export default mapUploadParams
